import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import ace from "brace";
import "brace/mode/json";
import "./themes/tiivii-dark";

const Editor = ({ value, onChange }) => {
  const containerRef = useRef(null);
  const editorRef = useRef(null);
  const suppressChange = useRef(false);

  useEffect(() => {
    const editor = ace.edit(containerRef.current);
    editorRef.current = editor;
    editor.getSession().setMode("ace/mode/json");
    editor.setTheme("ace/theme/tiivii-dark");
    editor.setOptions({
      fontSize: "14px",
      showPrintMargin: false,
      tabSize: 2,
      useSoftTabs: true,
      wrap: false,
    });

    editor.getSession().on("change", () => {
      if (suppressChange.current) return;
      const raw = editor.getValue();
      try {
        JSON.parse(raw);
        onChange({ json: raw, error: false });
      } catch (e) {
        onChange({ json: raw, error: e });
      }
    });

    return () => {
      editor.destroy();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const editor = editorRef.current;
    if (!editor) return;
    const newText = value ? JSON.stringify(value, null, 2) : "{}";
    if (editor.getValue() !== newText) {
      suppressChange.current = true;
      editor.setValue(newText, -1);
      suppressChange.current = false;
    }
  }, [value]);

  return (
    <div
      ref={containerRef}
      style={{ width: "100%", height: "100%", border: "1px solid #3c3c3c", borderRadius: "4px" }}
    />
  );
};

Editor.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
};

export default Editor;
